import axios from "axios";
import { toast } from "react-toastify";

const api = "https://api.jawanpakistan.com/";
// const localapi = 'http://localhost:5000/'


const getadminquiz = () => async (dispatch) => {
    dispatch({ type: "GET_ADMIN_QUIZ" });
  
    axios
      .get(`${api}result/allresults`)
      .then((res) => {
        console.log(res.data.results);
        dispatch({
          type: "GET_ADMIN_QUIZ_SUCCESS",
          payload: res.data.results,
        });
      })
      .catch((err) => {
        dispatch({ type: "GET_ADMIN_QUIZ_ERROR", payload: err.message });
        console.log(err);
      });
  };


  const filterquiz = (courseName,topicName,batchNo,classTime) => async (dispatch) => {
    dispatch({ type: "FILTER_ADMINQUIZ" });

    const obj = {
        courseName,
        topicName,
        batchNo,
        classTime
    }

    const options = {
        method:'POST',
        headers: { Accept: "application/json" },
        data: obj,
        url: `${api}result/seachQuizResult`,
    }

    axios(options).then((res) => {

        dispatch({type:'FILTER_ADMINQUIZ_SUCCESS',payload:res.data.results})
    }).catch(err => {
        dispatch({type:'FILTER_ADMINQUIZ_ERROR'})
        console.log(err)
    })


  }


  const getAllQuiz = () => async (dispatch) => {

    dispatch({type:'GET_ALL_QUIZ_REQUEST'})

    axios
      .get(`${api}quiz/getAllQuiz`)
      .then((res) => {
        dispatch({
          type: 'GET_ALL_QUIZ_REQUEST_SUCCESS',
          payload: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({ type: 'GET_ALL_QUIZ_REQUEST_ERROR', payload: err.message });
      });
  }

  const SwitchQuiz = (id) => async (dispatch) => {
    dispatch({type:'SWITCH_QUIZ_REQ'})

    axios
      .get(`${api}quiz/switchQuiz/${id}`)
      .then((res) => {
        dispatch({
          type: 'SWITCH_QUIZ_SUCCESS',
        });
        if(res.data.status === "OFF"){
          toast.success('Quiz Has Been Switched Off Successfully');
        }else{
          toast.success('Quiz Has Been Switched ON Successfully');
        }
        dispatch(getAllQuiz())
      })
      .catch((err) => {
        dispatch({ type: 'SWITCH_QUIZ_ERROR', payload: err.message });
      });


  }

  const DeleteQuiz = (id) => async (dispatch) => {
    dispatch({type:'DELETE_QUIZ_REQ'})

    axios
      .delete(`${api}quiz/deleteQuiz/${id}`)
      .then((res) => {
        dispatch({
          type: 'DELETE_QUIZ_SUCCESS',
        });
         toast.success('Quiz Has Been Deleted Successfully');
        dispatch(getAllQuiz())
      })
      .catch((err) => {
        dispatch({ type: 'DELETE_QUIZ_ERROR', payload: err.message });
        toast.error(err.message);

      });


  }

export {getadminquiz,filterquiz,getAllQuiz,SwitchQuiz,DeleteQuiz}
  